export default "__VITE_ASSET__PEltjpb5__"